class GlobalLevel {
    levelId;
    order;
    name;
    fixedPay;
    hours;
    payrate;
    pension;
    vacationDays;
    maxBonus;
    workPercentage;
    constructor(levelJson) {
        this.order = levelJson.order || '',
            this.name = levelJson.name || '';
        this.fixedPay = levelJson.fixedPay || 0;
        this.hours = levelJson.hours || 0;
        this.levelId = levelJson.id;
        this.payrate = levelJson.payrate || 0;
        this.pension = levelJson.pension || 0;
        this.vacationDays = levelJson.vacationDays || 0;
        this.maxBonus = levelJson.maxBonus || this.fixedPay * 2;
        this.workPercentage = levelJson.workPercentage || 100;
    }
}
export default GlobalLevel;
